export const MAX_AMOUNT = 1300000;
export const MIN_NUMBER_VALUE = 1;
export const MIN_NUMBER_VALUE_FOR_USD = 0.01;
export const MIN_NUMBER_VALUE_FOR_HKD = 0.01;
export const MIN_NUMBER_VALUE_FOR_PHP = 0.01;